<div nxLayout="grid">

  <!-- Filters -->
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12">
      <div nxLayout="grid" class="nx-margin-top-s">
        <div nxRow>
          <div nxCol="2">
            <nx-formfield>
              <input nxInput placeholder="Enter Keyword" [(ngModel)]="searchTerm" type="search" />
              <span nxFormfieldPrefix><nx-icon name="search" size="s"></nx-icon></span>
              <span nxFormfieldSuffix *ngIf="searchTerm" aria-hidden="true" (click)="searchTerm=''; getInvoiceList()">
                <nx-icon name="close" size="s"></nx-icon>
              </span>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Status">
              <nx-dropdown [(nxValue)]="statusFilter" (selectionChange)="pageNumber=1; getInvoiceList()">
                <nx-dropdown-item nxValue="All">All</nx-dropdown-item>
                <nx-dropdown-item nxValue="Submitted">Submitted</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Accepted">Invoice Accepted</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Rejected">Invoice Rejected</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Under Process">Invoice Under Process</nx-dropdown-item>
                <nx-dropdown-item nxValue="Invoice Paid">Invoice Paid</nx-dropdown-item>
              </nx-dropdown>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Start Date">
              <input nxDatefield nxInput [nxDatepicker]="startDatepicker" [(ngModel)]="startDate" />
              <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #startDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="End Date">
              <input nxDatefield nxInput [nxDatepicker]="endDatepicker" [(ngModel)]="endDate" />
              <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #endDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="4" class="nx-margin-top-2xs" style="display:flex; gap:8px; align-items:flex-start; flex-wrap:wrap;">
            <button nxButton="primary small-medium" type="button" (click)="pageNumber=1; getInvoiceList()">Search</button>
            <button nxButton="secondary small-medium" type="button" (click)="exportToExcel()">
              <nx-icon name="file-spreadsheet" class="nx-margin-right-2xs"></nx-icon>Export
            </button>
          </div>
        </div>
      </div>

      <!-- Commission Table -->
      <table nxTable zebra condensed nxSort (sortChange)="sortTable($event)" class="nx-margin-top-s">
        <thead>
          <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="dealerName">Dealer</th>
            <th nxHeaderCell nxSortHeaderCell="invoiceMonth">Invoice Period</th>
            <th nxHeaderCell nxSortHeaderCell="submittedOn">Submitted On</th>
            <th nxHeaderCell nxSortHeaderCell="comments">Dealer Comments</th>
            <th nxHeaderCell nxSortHeaderCell="status">Status</th>
            <th nxHeaderCell>Actions</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr nxTableRow *ngFor="let item of invoiceList">
            <td nxTableCell>{{ item.dealerName }}</td>
            <td nxTableCell>{{ months[item.invoiceMonth - 1] }} {{ item.invoiceYear }}</td>
            <td nxTableCell>{{ item.submittedOn | date:'dd/MM/yyyy' }}</td>
            <td nxTableCell class="comment-cell">{{ item.comments }}</td>
            <td nxTableCell>
              <nx-badge [type]="badgeType(item.status)">{{ item.status }}</nx-badge>
            </td>
            <td nxTableCell>
              <nx-context-menu #menu="nxContextMenu">
                <ng-template nxContextMenuContent>
                  <button nxContextMenuItem type="button" (click)="downloadInvoice(item.id, item.referenceNo)">
                    <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>Download Invoice
                  </button>
                  <button nxContextMenuItem type="button" *ngIf="canReview(item.status)"
                    (click)="openReviewModal('approve', item)">
                    Accept Invoice
                  </button>
                  <button nxContextMenuItem type="button" *ngIf="canReview(item.status)"
                    (click)="openReviewModal('reject', item)">
                    Reject Invoice
                  </button>
                  <button nxContextMenuItem type="button" *ngIf="canMarkUnderProcess(item.status)"
                    (click)="openStatusModal(item)">
                    Mark as Invoice Under Process
                  </button>
                  <button nxContextMenuItem type="button" *ngIf="canMarkPaid(item.status)"
                    (click)="openPaidModal(item)">
                    Mark as Invoice Paid
                  </button>
                  <button nxContextMenuItem type="button"
                    *ngIf="item.status === 'Invoice Paid' || item.status === 'Invoice Rejected'"
                    (click)="openDetailsModal(item)">
                    <nx-icon name="info-circle-o" class="nx-margin-right-2xs"></nx-icon>
                    {{ item.status === 'Invoice Paid' ? 'View Payment Details' : 'View Rejection Reason' }}
                  </button>
                </ng-template>
              </nx-context-menu>
              <button nxIconButton="tertiary medium" type="button" [nxContextMenuTriggerFor]="menu"
                aria-label="Open menu" nxTooltip="Actions" nxTooltipPosition="top">
                <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="count === 0" class="nx-margin-top-2xl">
        <div nxRow nxRowJustify="center">
          <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
        </div>
      </div>

      <div nxRow style="float: right" *ngIf="count > 0">
        <div nxCol="12">
          <nx-pagination
            [nxCount]="count"
            [nxPage]="pageNumber"
            [nxPerPage]="pageSize"
            nxType="advanced"
            (nxGoPrev)="prevPage()"
            (nxGoNext)="nextPage()"
            (nxGoPage)="goToPage($event)"
          ></nx-pagination>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- ===================== Commission Details Modal (Paid / Rejected) ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="detailsModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">
          {{ selectedInvoice.status === 'Invoice Paid' ? 'Payment Details' : 'Rejection Reason' }}
        </h3>
      </div>
    </div>

    <ng-container *ngIf="selectedInvoice.status === 'Invoice Paid'">
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">UTR / Transaction ID</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.utrNumber || '—' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">Payment Date</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.paymentDate | date:'dd/MM/yyyy' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">Amount Paid</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.amountPaid | currency:'INR':'symbol':'1.2-2' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs" *ngIf="selectedInvoice.paymentRemarks">
        <div nxCol="5" class="detail-label">Remarks</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.paymentRemarks }}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedInvoice.status === 'Invoice Rejected'">
      <div nxRow class="nx-margin-top-2xs">
        <div nxCol="5" class="detail-label">Reason for Rejection</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.rejectionReason || '—' }}</div>
      </div>
      <div nxRow class="nx-margin-top-2xs" *ngIf="selectedInvoice.reviewedOn">
        <div nxCol="5" class="detail-label">Reviewed On</div>
        <div nxCol="7" class="detail-value">{{ selectedInvoice.reviewedOn | date:'dd/MM/yyyy' }}</div>
      </div>
    </ng-container>

    <div nxRow class="nx-margin-top-m">
      <div nxCol="12">
        <button nxButton="block secondary" type="button" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- ===================== Mark Under Process Confirmation ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="statusModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">Mark as Invoice Under Process</h3>
        <p nxCopytext="normal">
          Are you sure you want to mark invoice <strong>{{ selectedInvoice.referenceNo }}</strong>
          ({{ months[selectedInvoice.invoiceMonth - 1] }} {{ selectedInvoice.invoiceYear }}) as <strong>Invoice Under Process</strong>?
        </p>
      </div>
    </div>
    <div nxRow class="nx-margin-top-m">
      <div nxCol="6">
        <button nxButton="block primary" type="button" [disabled]="statusInProgress" (click)="markUnderProcess()">
          {{ statusInProgress ? 'Saving...' : 'Confirm' }}
        </button>
      </div>
      <div nxCol="6">
        <button nxButton="block secondary" type="button" (click)="closeStatusModal()">Cancel</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- ===================== Review Modal (Approve / Reject) ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="reviewModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="selectedInvoice">
    <div nxRow>
      <div nxCol="12">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">
          {{ reviewMode === 'approve' ? 'Accept Invoice' : 'Reject Invoice' }}
        </h3>
        <p nxCopytext="small" class="detail-ref">
          Reference: {{ selectedInvoice.referenceNo }} &mdash;
          {{ months[selectedInvoice.invoiceMonth - 1] }} {{ selectedInvoice.invoiceYear }} &mdash;
          Dealer: {{ selectedInvoice.dealerName }}
        </p>
      </div>
    </div>

    <div nxRow class="nx-margin-top-2xs">
      <div nxCol="12">
        <button nxButton="block tertiary small-medium" type="button"
          (click)="downloadInvoice(selectedInvoice.id, selectedInvoice.referenceNo)">
          <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>Download Invoice PDF
        </button>
      </div>
    </div>

    <form [formGroup]="reviewForm">
      <div nxRow class="nx-margin-top-s">
        <div nxCol="12">
          <nx-formfield [nxLabel]="reviewMode === 'reject' ? 'Reason for Rejection' : 'Comments (optional)'">
            <textarea nxInput formControlName="adminComments" rows="4"
              [placeholder]="reviewMode === 'reject'
                ? 'Provide the reason for rejection (required)'
                : 'Add any remarks for the dealer (optional)'"></textarea>
            <nx-error nxFormfieldError>
              <strong>Please note:</strong> Please provide a reason for rejection.
            </nx-error>
          </nx-formfield>
        </div>
      </div>
    </form>

    <div nxRow class="nx-margin-top-s">
      <div nxCol="6">
        <button nxButton="block primary" type="button" [disabled]="reviewInProgress"
          [class.is-danger]="reviewMode === 'reject'" (click)="submitReview()">
          {{ reviewInProgress ? 'Saving...' : (reviewMode === 'approve' ? 'Accept' : 'Reject') }}
        </button>
      </div>
      <div nxCol="6">
        <button nxButton="block secondary" type="button" (click)="closeReviewModal()">Cancel</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- ===================== Mark Paid Modal ===================== -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="paidModalOpen" [nxShowCloseIcon]="false">
  <div class="paid-modal" *ngIf="selectedInvoice">
    <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold nx-margin-bottom-2xs">Mark Invoice as Paid</h3>

    <form [formGroup]="paidForm" class="paid-modal-form">

      <nx-formfield nxLabel="UTR / Transaction ID">
        <input nxInput formControlName="utrNumber" placeholder="e.g. NEFT123456789" />
        <nx-error nxFormfieldError>
          <strong>Please note:</strong> UTR / Transaction ID is required.
        </nx-error>
      </nx-formfield>

      <div class="paid-modal-row">
        <nx-formfield nxLabel="Payment Date">
          <input nxDatefield nxInput [nxDatepicker]="paymentDatepicker" formControlName="paymentDate" />
          <nx-datepicker-toggle [for]="paymentDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
          <nx-datepicker #paymentDatepicker></nx-datepicker>
          <nx-error nxFormfieldError>
            <strong>Please note:</strong> Payment date is required.
          </nx-error>
          <span nxFormfieldHint>MM/DD/YYYY</span>
        </nx-formfield>

        <nx-formfield nxLabel="Amount Paid (₹)">
          <input nxInput formControlName="amountPaid" placeholder="e.g. 12500.00" />
          <nx-error nxFormfieldError>
            <strong>Please note:</strong> Please enter a valid amount.
          </nx-error>
        </nx-formfield>
      </div>

      <nx-formfield nxLabel="Transaction Remarks (optional)">
        <textarea nxInput formControlName="paymentRemarks" rows="3"
          placeholder="e.g. NEFT transfer from HDFC bank"></textarea>
      </nx-formfield>

    </form>

    <div class="paid-modal-actions nx-margin-top-m">
      <button nxButton="block primary" type="button" [disabled]="paidInProgress" (click)="submitPaid()">
        {{ paidInProgress ? 'Saving...' : 'Mark as Paid' }}
      </button>
      <button nxButton="block secondary" type="button" (click)="closePaidModal()">Cancel</button>
    </div>
  </div>
</nx-modal>
